import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Resource, ResourceId } from '@toolproof-core/genesis/_contract/_index';

export interface NaturalSliceState {
    naturalResourceById: Record<ResourceId, Resource>;
}

const initialState: NaturalSliceState = {
    naturalResourceById: {},
};

const naturalSlice = createSlice({
    name: 'natural',
    initialState,
    reducers: {
        addNatural: (state, action: PayloadAction<Resource>) => {
            const resource = action.payload;
            state.naturalResourceById[resource.id as ResourceId] = resource;
        },
        clearNaturals: (state) => {
            state.naturalResourceById = {};
        },
    },
});

export const { addNatural, clearNaturals } = naturalSlice.actions;
export default naturalSlice.reducer;